/** @format */

import FallbackIcon from '@atoms/FallbackIcon';
import { ResourceUrl } from '@common/application/helpers/generateSignedUrlsForResults';
import { css } from '@emotion/react';
import Image from 'next/legacy/image';
import React from 'react';

interface TableImageProps {
  maxHeight?: string;
  maxWidth?: string;
  resource: ResourceUrl;
}

function TableImage(props: TableImageProps) {
  const maxHeight = props.maxHeight ?? '48px';
  const maxWidth = props.maxWidth ?? '48px';

  return (
    <span
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {props.resource?.url ? (
        <Image
          style={{ margin: '0 auto', maxHeight, maxWidth, width: 'auto', height: 'auto' }}
          height={48}
          width={48}
          objectFit={'contain'}
          src={props.resource.url as string}
          alt={'logo'}
        />
      ) : (
        <FallbackIcon
          isImage={true}
          css={css`
            max-height: ${maxHeight};
            height: 38px;
            margin: 0 auto;
          `}
          resourceStatus={props.resource?.urlStatus}
        />
      )}
    </span>
  );
}

export default TableImage;
